<template>
  <vs-popup title="Renvoyer le code de consultation" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-col vs-w="6">
        <vs-input v-model="phone"
        :danger="errors.phone ? true : false"
        :danger-text="errors.phone ? errors.phone[0] : ''"
        label="Entrer le numéro du client sans l'indicatif" class="w-full"></vs-input>
      </vs-col>
      <vs-col vs-w="6">
        <vs-button color="primary" class="mt-6 ml-5" type="filled" @click="reSendCode()">Valider</vs-button>
      </vs-col>
    </vs-row><br>
  </vs-popup>
</template>

<script>
    export default {
      name: "detail",
      props: {
        isPromptActive: {
          type: Boolean,
          required: true
        },
      },
      watch: {
        isPromptActive(val) {
          if (!val) return;
        }
      },
      data:() => ({
        errors: [],
        phone: ''
      }),
      computed: {
        isPromptActiveLocal: {
          get() {
            return this.isPromptActive
          },
          set(val) {
            if (!val) {
              this.$emit('closePrompt')
            }
          }
        },
      },
      methods:{
        reSendCode(){
          this.$vs.loading();
          this.$http
            .post("/payment/return-code", {phone: this.phone})
            .then((response) => {
              this.$vs.loading.close();
              this.errors = []
              if (response.data.status){
                this.phone = ''
                this.$vs.notify({
                  title: 'Succès',
                  text: 'Opération réussie',
                  color: 'success',
                  iconPack: 'feather',
                  icon: 'icon-check',
                  position: 'top-right'
                })
                this.$emit('closePrompt')
              }else{
                this.$vs.notify({
                  title: 'Erreur',
                  text: 'Une erreur est survenu lors de l\'opération',
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-check',
                  position: 'top-right'
                })
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              if (error.response.status === 401) {
                this.$vs.notify({
                  title: 'Erreur',
                  text: 'Votre session a expiré',
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-check',
                  position: 'top-right'
                })
                this.$router.push({name: "page-login"})
              }else this.errors = error.response.data.errors
            });
          }
      }
    }
</script>

<style scoped>

</style>
